import React, { Fragment } from 'react';

/**
 * Renders a collection of square badges with optional additional user count.
 *
 * @deprecated Use components/Avatar instead
 */
const SquareBadges = ({ data, additionalUsers }) => (
  <div className="flex items-center gap-1">
    {data.map((item, i) => (
      <Fragment key={`${item.id}-${i}` || i}>
        <div className="w-12 h-12 object-cover rounded-lg border-2 border-primary-300 overflow-hidden align-center justify-center flex">
          <img
            alt={item.name}
            src={item?.badgeImageUrl || '/img/search/user.svg'}
          />
        </div>
      </Fragment>
    ))}
    {additionalUsers > 0 && (
      <div className="w-12 h-12 object-cover rounded-lg border-2 border-primary-300 overflow-hidden align-center justify-center flex">
        +{additionalUsers}
      </div>
    )}
  </div>
);

export default SquareBadges;
